import gsap from "gsap";

import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const createTimeline = (els) => {
  let tl = gsap.timeline({ paused: true });

  tl.fromTo(
    els,
    {
      opacity: 0,
      y: "0.625rem",
    },
    {
      opacity: 1,
      y: 0,
      stagger: 0.1,
    },
    0
  );

  return tl;
};

export const refreshScrollTriggers = () => {
  window.scrollTriggers.map((st) => {
    st.refresh();
  });
};

export const initOnScrollAnimation = (section) => {
  let animateable_els = section.querySelectorAll(".js-animate");

  let tl = createTimeline(animateable_els);

  window.scrollTriggers.push(
    ScrollTrigger.create({
      trigger: section,
      start: "top top+=75%",
      onEnter: () => {
        tl.play();
      },
      // onLeaveBack: () => {
      //   tl.reverse();
      // },
    })
  );
};
